import styled from 'styled-components';

import { commonSkeletonStyles, flexBetween, flexColumn } from '@/styles/common';

export const Wrapper = styled.div<{ $isMobile: boolean }>`
  height: ${({ $isMobile }) => ($isMobile ? '245px' : '294px')};
  background-color: var(--bg-card);
  border-radius: 28px;
  padding: 20px 20px 25px;
  ${flexColumn}
  gap: 15px;
  color: var(--textAndLabels-main);
  border: 1px solid var(--border-secondary);
`;

export const Header = styled.div`
  padding: 10px 0px;
`;

export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 17px;
`;

export const InfoLines = styled.div`
  ${flexColumn}
  flex-grow: 1;
  gap: 5px;
`;

export const Content = styled.div<{ $isBig: boolean }>`
  ${flexColumn}
  gap: ${({ $isBig }) => ($isBig ? '10px' : '20px')};
  padding-bottom: 14px;
  flex: 1;
`;

export const Footer = styled.div`
  ${flexBetween}
`;

export const SkeletonLine = styled.div<{ width?: number; height?: number }>`
  width: ${({ width }) => `${width ? width : 100}%`};
  height: ${({ height }) => `${height ? height : 10}px`};
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const SkeletonCircle = styled.div<{ $size: number }>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 110px;
  ${commonSkeletonStyles}
`;

export const Chips = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  /* margin: 20px 0; */
`;
